// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: ':checklistId/project-checklist-task-templates/new',
        component: () =>
            import(/* webpackChunkName: "project-management.project-checklist-task-templates" */ '@/pages/[organisation]/projects/project-checklist-task-templates/project-checklist-task-template/new.vue'),
        name: 'project-management.project-checklist-task-templates.create-checklist-task-template',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist-task-templates.create-project-checklist-task-template',
        },
    },
    {
        path: ':checklistId/project-checklist-task-templates/:taskId',
        component: () =>
            import(/* webpackChunkName: "project-management.project-checklist-task-templates" */ '@/pages/[organisation]/projects/project-checklist-task-templates/project-checklist-task-template/[id].vue'),
        name: 'project-management.project-checklist-task-templates.view-checklist-task-template',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist-task-templates.view-project-checklist-task-templates',
        },
    },
    {
        path: ':checklistId/project-checklist-task-templates/:taskId/edit',
        component: () =>
            import(/* webpackChunkName: "project-management.project-checklist-task-templates" */ '@/pages/[organisation]/projects/project-checklist-task-templates/project-checklist-task-template/[id]/edit.vue'),
        name: 'project-management.project-checklist-task-templates.update-checklist-task-template',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist-task-templates.update-project-checklist-task-template',
        },
    },
    {
        path: ':checklistId/project-checklist-task-templates/:taskId/archive',
        component: () =>
            import(/* webpackChunkName: "project-management.project-checklist-task-templates" */ '@/pages/[organisation]/projects/project-checklist-task-templates/archived-project-checklist-task-template/[id].vue'),
        name: 'project-management.project-checklist-task-templates.view-archived-checklist-task-template',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist-task-templates.view-project-checklist-task-templates',
        },
    },
    {
        path: ':checklistId/project-checklist-task-templates/:taskId/bin',
        component: () =>
            import(/* webpackChunkName: "project-management.project-checklist-task-templates" */ '@/pages/[organisation]/projects/project-checklist-task-templates/binned-project-checklist-task-template/[id].vue'),
        name: 'project-management.project-checklist-task-templates.view-binned-checklist-task-template',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist-task-templates.view-project-checklist-task-templates',
        },
    },
];
